<app-topnav [pageName]="pageName"></app-topnav>

<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="facility-heading">Edit Course</div>
    <div class="designatedFacilityForm">

      <mat-tab-group [(selectedIndex)]="selectedTab">
        <ng-container>
          <mat-tab label="Tab 1" tabindex="0" >
            <ng-template mat-tab-label >Details</ng-template>
            <app-course-details #coursedetails
              [course]="course"
              [isSubmitted]="isSubmitted"
              [selectedPrograms]="selectedPrograms"
              [selectedTags]="selectedTags"
              [courseStatus]="courseStatus"
              [hasEnrolledUsers]="hasEnrolledUsers"
              [disabledPrograms]="disabledPrograms">
            </app-course-details>
          </mat-tab>
        </ng-container>

        <ng-container>
          <mat-tab label="Tab 2" tabindex="1" >
            <ng-template mat-tab-label>Materials</ng-template>
            <app-course-materials [course]="course" [hasEnrolledUsers]="hasEnrolledUsers"></app-course-materials>
          </mat-tab>
        </ng-container>
      </mat-tab-group>

      <div class="form-buttons">
        <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit"/>
        <a routerLink="/course-list" class="submit-form-button cancel-button">Cancel</a>
      </div>
    </div>
  </div>
</div>

@if (modalOpen | async) {
  <app-modal [title]="modalTitle" [content]="modalContent" [okButtonValue]="modalOkButtonValue"
  [cancelButtonValue]="modalCancelButtonValue" [okButtonText]="modalOkButtonText" [cancelButtonText]="modalCancelButtonText"></app-modal>
}
<app-footer [bbapp]="true"></app-footer>


